<template>
  <div>
    <via-nav-bar
      title="修改资料"
      @click-left="$router.$back()"
    >
      <div
        slot="right"
        class="nav-right"
        @click="confirm"
      >保存</div>
    </via-nav-bar>

    <!-- 表单 -->
    <van-cell-group>
      <van-field
        v-model="form.nickname"
        required
        clearable
        :maxlength="10"
        label="昵称"
        placeholder="不能和别人相同"
      />
      <van-field
        v-model="form.introduction"
        required
        clearable
        :maxlength="30"
        label="个性签名"
        placeholder="30字以内"
      />
      <van-cell
        required
        title="头像"
        class="avatar-title"
      >
        <van-uploader
          v-model="uploadList"
          multiple
          :max-size="maxSize"
          :max-count="1"
          :after-read="uploadAfterReadHandle"
          @oversize="uploadOverSizeHandle"
        />
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Uploader } from 'vant'
import axios from 'axios'

export default {
  name: 'UpdateUser',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      uploadList: [],
      form: {
        nickname: '',
        introduction: '',
        avatar: ''
      }
    }
  },
  computed: {
    maxSize() {
      return 2 * 1024 * 1024
    },
    avatarFile() {
      const timestamp = new Date().getTime()
      return {
        lastModified: timestamp,
        lastModifiedDate: timestamp,
        name: `${timestamp}.png`,
        size: 4502,
        type: 'image/png',
        webkitRelativePath: ''
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const userInfo = this.$store.getters['globalData/userInfo']
      const { nickname, introduction, avatar } = userInfo
      this.form = { nickname, introduction, avatar: this.$imgHook(avatar) }
      this.uploadList = [{
        content: this.$imgHook(avatar),
        file: this.avatarFile
      }]
    },
    // 图片超过大小限制
    uploadOverSizeHandle() {
      this.$toast.fail('图片最大2m')
    },
    // 图片上传
    uploadAfterReadHandle(file, detail) {
      this.$store.commit('globalData/updateLoading', true)
      const formdata = new FormData()
      formdata.append('smfile', file.file)
      axios({
        url: 'https://cors-anywhere.herokuapp.com/https://sm.ms/api/upload',
        method: 'post',
        data: formdata,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.$store.commit('globalData/updateLoading', false)
        this.$toast.success('图片上传成功')
        console.log(this.uploadList)
        this.form.avatar = res.data.data.url
      }).catch(() => {
        this.$store.commit('globalData/updateLoading', false)
        this.uploadList = []
        this.$toast.fail('图片上传失败')
      })
    },
    confirm() {
      if (!this.validatedForm()) {
        return
      }
      const {
        nickname,
        introduction,
        avatar
      } = this.form
      this.$store.commit('globalData/updateLoading', true)
      this.$api.user.update({
        nickname,
        introduction,
        avatar
      }).then(res => {
        this.$store.commit('globalData/updateLoading', false)
        this.$store.dispatch('globalData/getMeInfo')
        this.$toast.success('修改成功')
      }).catch(() => this.$store.commit('globalData/updateLoading', false))
    },
    // 校验表单
    validatedForm() {
      const {
        nickname,
        introduction,
        avatar
      } = this.form
      if (!nickname) {
        this.$toast.fail('昵称不能为空')
        return false
      }
      if (!introduction) {
        this.$toast.fail('个性签名不能为空')
        return false
      }
      if (!avatar) {
        this.$toast.fail('请完善头像')
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.nav-right {
  color: var(--themeColor)
}
</style>
<style>
.avatar-title .van-cell__title {
  width: 90px;
  flex: none;
}
.avatar-title .van-cell__value {
  text-align: left;
}
</style>
